'use client'

import { useQuery } from '@tanstack/react-query'
import { getLocations } from '@/lib/actions/global/get-locations'
import { cn } from '@/lib/utils'

import { BranchCardList, ScrollArea } from '@/components/ui'

interface BranchListProps extends React.ComponentPropsWithoutRef<'div'> {}

export const BranchList = ({ className }: BranchListProps) => {
  const {
    data: locations,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['locations'],
    queryFn: () => getLocations(),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  })

  if (isLoading) {
    return (
      <ScrollArea
        className={cn(
          'relative w-full overflow-auto pr-4',
          'before:absolute before:left-0 before:right-0 before:top-0 before:z-10 before:h-8 before:bg-gradient-to-b before:from-gray-50 before:to-transparent before:content-[""]',
          'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-8 after:bg-gradient-to-t after:from-gray-50 after:to-transparent after:content-[""]',
          className,
        )}
        thumbClassName="bg-transparent"
      >
        <div className="flex flex-col gap-1 py-8">
          <div className="h-12 w-full animate-pulse rounded-md bg-gray-100" />
          <div className="h-12 w-full animate-pulse rounded-md bg-gray-100" />
          <div className="h-12 w-full animate-pulse rounded-md bg-gray-100" />
        </div>
      </ScrollArea>
    )
  }

  if (error) {
    return (
      <ScrollArea
        className={cn(
          'relative w-full overflow-auto pr-4',
          'before:absolute before:left-0 before:right-0 before:top-0 before:z-10 before:h-8 before:bg-gradient-to-b before:from-gray-50 before:to-transparent before:content-[""]',
          'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-8 after:bg-gradient-to-t after:from-gray-50 after:to-transparent after:content-[""]',
          className,
        )}
        thumbClassName="bg-transparent"
      >
        <div className="flex flex-col gap-1 py-8">
          <div className="text-center text-sm text-gray-500">
            Failed to load locations
          </div>
        </div>
      </ScrollArea>
    )
  }

  return (
    <ScrollArea
      className={cn(
        'relative w-full overflow-auto pr-4',
        'before:absolute before:left-0 before:right-0 before:top-0 before:z-10 before:h-8 before:bg-gradient-to-b before:from-gray-50 before:to-transparent before:content-[""]',
        'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-8 after:bg-gradient-to-t after:from-gray-50 after:to-transparent after:content-[""]',
        className,
      )}
      thumbClassName="bg-transparent"
    >
      <BranchCardList
        className="flex flex-col gap-1 py-8"
        list={locations ?? []}
      />
    </ScrollArea>
  )
}
